import { JSX } from "react";
import { AutocompleteArrayInput, NullableBooleanInput, RadioButtonGroupInput, required, useGetList } from "react-admin";
import { useWatch } from "react-hook-form";
import { nokEmailTemplateStatuses } from "../../../../defaults/defaults";

/**
 * Who a Nok email template is offered to: its status, industries and sender type. The Mystery
 * Shopper composer offers an active message body only for the sender's industry, and one with no
 * industries for none, so `ms_email_body` needs at least one (HQ-API's `NokEmailTemplateImporter`
 * applies the same rule). Only that composer reads industries and sender type, so the two fields
 * show for `ms_email_body` alone; another type keeps whatever it has stored (user, 2026-10-20).
 * Shared by the create and edit forms.
 */
export const NokEmailTemplateTargetInputs: () => JSX.Element = (): JSX.Element => {
    const type: string | undefined = useWatch({ name: 'type' });
    const { data } = useGetList('industries', { pagination: { page: 1, perPage: 500 } });
    const industries: { id: number, name: string }[] = (data ?? []).map( (item): { id: number, name: string } => ({ id: Number(item.id), name: item.name }) );
    const isMysteryShopperBody: boolean = type === 'ms_email_body';

    return (
        <>
            <RadioButtonGroupInput source="status"
                                   choices={ nokEmailTemplateStatuses }
                                   defaultValue="active"
                                   validate={ [required()] }
                                   helperText="A disabled template is never offered in a composer." />
            { isMysteryShopperBody && (
                <>
                    <AutocompleteArrayInput source="industries"
                                            choices={ industries }
                                            defaultValue={ [] }
                                            validate={ [required()] }
                                            sx={ { minWidth: 300 } }
                                            helperText="Offered only to senders in these industries." />
                    <NullableBooleanInput source="isBusiness"
                                          label="Sender type"
                                          nullLabel="Either"
                                          trueLabel="Company senders"
                                          falseLabel="Consumer senders"
                                          helperText="Which Mystery Shopper senders are offered this template." />
                </>
            ) }
        </>
    );
};
